//src/hooks/useAsignarFormador.ts
import { useMutation } from "@tanstack/react-query";
import { asignarFormador } from "../api/formaciones";

export function useAsignarFormador() {
  return useMutation({
    mutationFn: asignarFormador,
  });
}
